import ApiService from '@/common/api.service'
export default {
  messageDetail (id) {
    return new Promise((resolve, reject) => {
      ApiService.query('/emergency-message/detail/' + id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
